<template>
    hello waffler!
  <router-view/>
</template>

<style>

</style>
